
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/compound-interests-calculator",
      function () {
        return require("private-next-pages/tools/compound-interests-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/compound-interests-calculator"])
      });
    }
  